import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Kestrel',
    description: 'Track revenue, recurring income, customers and churn for your subscription business in one clear dashboard.',
    url: getOrigin()
}
